<!-- Icon -->
<span
    hamIconShapes
    class="icon"
    icon="assets/hamIcons/bullhorn.svg"
    [variant]="'orange'"
    [size]="'regular'"
    style="align-self: flex-start"
></span>
<!-- Text -->
<div class="banner-content">
    <span *ngIf="messageLocalizationKey" class="banner-text">
        {{ messageLocalizationKey | i18next }}
        <a *ngIf="hasLink" [href]="linkUrl" target="_blank" rel="noopener noreferrer" class="announcement-link">
            {{ linkDisplayText }}
        </a>
    </span>
    <span *ngIf="!messageLocalizationKey && message" class="banner-text">
        {{ displayMessage }}
        <a *ngIf="hasLink" [href]="linkUrl" target="_blank" rel="noopener noreferrer" class="announcement-link">
            {{ linkDisplayText }}
        </a>
    </span>
</div>

<!-- ← Spacer takes all the remaining space → -->
<div class="flex-spacer"></div>

<!-- Dismiss button (X) -->
<ham-button
    style="align-self: flex-start"
    *ngIf="dismissible"
    variant="glass"
    [size]="'xs'"
    icon="assets/hamIcons/x.svg"
    (buttonClick)="onDismiss()"
>
</ham-button>

<!-- Action button -->
<ham-button
    style="align-self: flex-start"
    *ngIf="hasButton"
    variant="glass"
    (buttonClick)="onConfirm()"
    outline="true"
    size="xs"
    >{{ buttonLocalizationKey | i18next }}</ham-button
>
